import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-userlogin',
  templateUrl: './userlogin.component.html',
  styleUrls: ['./userlogin.component.scss']
})
export class UserloginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
